import { render } from "./vgointype.vue?vue&type=template&id=7694cee6&scoped=true"
import script from "./vgointype.vue?vue&type=script&lang=js"
export * from "./vgointype.vue?vue&type=script&lang=js"

import "./vgointype.vue?vue&type=style&index=0&id=7694cee6&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境总后台manage.jsyinba.com/jsgeneral/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7694cee6"]])

export default __exports__